import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Box, Container, Typography, Button, Alert } from "@mui/material";
import { api } from "../services/api";

export const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<"loading" | "success" | "error">(
    "loading",
  );
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    if (token) {
      verifyEmail(token);
    }
  }, [searchParams]);

  const verifyEmail = async (token: string) => {
    try {
      const response = await api.get(`/auth/verify-email?token=${token}`);
      setStatus("success");
      setMessage("Email verified successfully! You can now log in.");
      setTimeout(() => navigate("/login"), 3000);
    } catch (error) {
      setStatus("error");
      setMessage(
        "Verification failed. Please try again or request a new verification email.",
      );
    }
  };

  const handleResendVerification = async () => {
    if (!email) {
      setMessage("Please enter your email address");
      return;
    }

    try {
      await api.post("/auth/resend-verification", { email });
      setMessage("Verification email sent! Please check your inbox.");
    } catch (error) {
      setMessage("Failed to resend verification email. Please try again.");
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          Email Verification Not Required
        </Typography>
        <Alert severity="info" sx={{ width: "100%" }}>
          Email verification is not required. You can log in immediately after registering.
        </Alert>
        <Button variant="contained" color="primary" href="/login">
          Go to Login
        </Button>
      </Box>
    </Container>
  );
};
